<template>
    <Wrapper>
        <Topbar button="goToPanel" logo="buybox" step="2/2" />
        <h2 class="text-center mb-3">{{ $t('header') }}</h2>
        <p class="text-center pre-line mb-4">{{ $t('description') }}</p>
        <FeatureColumns :columns="columns" />
        <p class="text-center">{{ $t('description2') }}</p>
    </Wrapper>
</template>



<script>
    import Wrapper from '../../parts/Wrapper.vue';
    import Topbar from '../../parts/Topbar.vue';
    import FeatureColumns from '../../parts/FeatureColumns.vue';

    export default {
        name: 'AccountReady',
        components: {
            Wrapper,
            Topbar,
            FeatureColumns,
        },
        computed: {
            columns() {
                return Object.values(this.$t('columns')).map(column => ({ ...column, items: Object.values(column.items) }));
            },
        },
        created() {
            this.$store.commit('space/setSpacesInitialized', false);
        },
    };
</script>



<i18n lang="json" locale="pl" scope="local">
{
    "header": "Twoje konto jest gotowe 🎉",
    "subheader": "",
    "description": "Afiliacja to świetny sposób na monetyzację Twojej strony lub social mediów.\nNa początek wybierz narzędzie, z którego chcesz skorzystać w pierwszej kolejności.",
    "description2": "Pamiętaj, że nie wybierasz raz na zawsze — to tylko pierwszy krok. Wszystkie narzędzia są dostępne z poziomu Twojego konta.",
    "columns": [
        {
            "title": "Linki partnerskie",
            "description": "Prosto i szybko — znajdź produkt, skopiuj link i podziel się nim.",
            "items": ["Najprostszy sposób na start", "Działa wszędzie: na blogu, w socialach, w newsletterze", "Prosty generator linków partnerskich"],
            "button": {
                "label": "Wybieram",
                "to": { "name": "TextLinks" }
            }
        },
        {
            "title": "Widżet produktowy",
            "description": "Intuicyjny widżet z listą dostępnych sklepów oferujących promowany produkt. Możesz go osadzić na stronie w kilka sekund.",
            "items": ["Świetny dla blogów, recenzji i artykułów produktowych", "Nowoczesny wygląd i wysoka konwersja", "Możliwość personalizacji"],
            "button": {
                "label": "Wybieram",
                "to": { "name": "WidgetGenerator" }
            }
        },
        {
            "title": "Landing page produktowy",
            "description": "Strona z produktem, listą dostępnych sklepów oraz porównaniem cen — gotowa do podzielenia się.",
            "items": ["Idealne do wykorzystania w social mediach – wystarczy opublikować przygotowany link", "Łatwy i intuicyjny generator", "Bez kodowania, gotowe od ręki"],
            "button": {
                "label": "Wybieram",
                "to": { "name": "ProductLandingPageGenerator" }
            }
        }
    ]
}
</i18n>

<i18n lang="json" locale="en" scope="local">
{
    "header": "Your account is ready 🎉",
    "subheader": "",
    "description": "Affiliate marketing is a great way to monetize your website or social media.\nTo begin, choose the tool you want to use first.",
    "description2": "Remember, you’re not choosing forever — it’s just the first step. All tools are available from your account.",
    "columns": [
        {
            "title": "Affiliate links",
            "description": "Simple and fast — find a product, copy the link, and share it.",
            "items": ["The easiest way to get started", "Works everywhere: on your blog, on social media, in newsletters", "Easy affiliate link generator"],
            "button": {
                "label": "Select",
                "to": { "name": "TextLinks" }
            }
        },
        {
            "title": "Product widget",
            "description": "An intuitive widget with a list of stores offering the promoted product. You can embed it on your site in seconds.",
            "items": ["Great for blogs, reviews, and product articles", "Modern look and high conversion", "Customizable options"],
            "button": {
                "label": "Select",
                "to": { "name": "WidgetGenerator" }
            }
        },
        {
            "title": "Product landing page",
            "description": "A page with the product, a list of available stores, and price comparison — ready to share.",
            "items": ["Perfect for social media — just publish the generated link", "Easy-to-use, intuitive generator", "No coding required, ready out of the box"],
            "button": {
                "label": "Select",
                "to": { "name": "ProductLandingPageGenerator" }
            }
        }
    ]
}
</i18n>

